import UPDATE_PRODUCT_SEARCH_FOCUS_CLASS from '../actionTypes/ProductSearchFocusActionTypes';

const updateProductSearchFocusClass = (payload) => ({
    type: UPDATE_PRODUCT_SEARCH_FOCUS_CLASS,
    payload,
});

export default updateProductSearchFocusClass;
